import { useEffect } from "react"

export const NoRestart = () => {

	useEffect(() => {
		console.log('render norestart')
	}, [])

	return (
		<div>
			<h2>norestart</h2>
		</div>
	)
}
